<template>
    <b-modal id="m-detail-item" title="Detail Item" size="lg" hide-footer>
        <div v-if="item">
            <h6 class="font-weight-bold">Informasi Barang</h6>
            <hr class="mt-1" />
            <b-row>
                <b-col md="6">
                    <b-form-group label="No. Faktur Barang">
                        <b-form-input
                            :value="item.item_no_faktur"
                            readonly
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Barang">
                        <b-form-input
                            :value="
                                `${item.item_type} (${item.item_kind} - ${
                                    item.item_brand
                                })`
                            "
                            readonly
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Harga (Original)">
                        <b-input-group prepend="Rp.">
                            <b-form-input
                                :value="
                                    $helper.formatThousand(
                                        item.invoice_detail_total
                                    )
                                "
                                readonly
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Subtotal (Penjualan)">
                        <b-input-group prepend="Rp.">
                            <b-form-input
                                :value="$helper.formatThousand(item.subtotal)"
                                readonly
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="4">
                    <b-form-group label="Diskon Penjual">
                        <b-input-group prepend="Rp.">
                            <b-form-input
                                :value="$helper.formatThousand(item.discount)"
                                readonly
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Biaya Marketplace">
                        <b-input-group prepend="Rp.">
                            <b-form-input
                                :value="$helper.formatThousand(item.fee_total)"
                                readonly
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Total Akhir">
                        <b-input-group prepend="Rp.">
                            <b-form-input
                                :value="$helper.formatThousand(item.total)"
                                class="font-weight-bold text-primary"
                                readonly
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <h6 class="font-weight-bold mt-3">Rincian Biaya Marketplace</h6>
            <hr class="mt-1" />
            <b-table
                striped
                hover
                bordered
                :items="item.fees"
                :fields="feeFields"
                show-empty
            >
                <template v-slot:empty>
                    <div class="text-center">
                        Tidak ada biaya untuk item ini.
                    </div>
                </template>
                <template v-slot:cell(fee_name)="row">
                    {{
                        row.item.master_marketplace_fee
                            ? row.item.master_marketplace_fee.name
                            : "-"
                    }}
                </template>
                <template v-slot:cell(amount)="row">
                    Rp. {{ $helper.formatThousand(row.item.amount) }}
                </template>
            </b-table>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            feeFields: [
                { key: "fee_name", label: "Nama Biaya" },
                { key: "amount", label: "Nominal", class: "text-right" }
            ]
        };
    }
};
</script>
